// Tarjeta de estadística (port de statCard). chip de color + label + value + desc.
// La barra de acento superior (::before) toma el color del icono vía --stat-accent.
import type { CSSProperties, ReactNode } from 'react';
import type { ChipColor } from './Modal';

interface StatCardProps {
  icon: string;
  color: ChipColor;
  label: string;
  value: ReactNode;
  desc?: string;
  badge?: ReactNode;
}

export function StatCard({ icon, color, label, value, desc, badge }: StatCardProps) {
  const style = { '--stat-accent': `var(--${color})` } as CSSProperties;
  return (
    <div className="card stat hoverable" style={style}>
      <span className={`chip c-${color}`}><i className={`fa-solid ${icon}`} /></span>
      <span className="stat-label">{label}</span>
      <span className="stat-value">{value}</span>
      {badge ?? <span className="stat-desc">{desc || ''}</span>}
    </div>
  );
}
